import React from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField,
} from '@material-ui/core'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Table31 } from './Tables/TableSec3/Table31'
import { Table33 } from './Tables/TableSec3/Table33'
import { Table34 } from './Tables/TableSec3/Table34'
import { TableLinkedIn } from './Tables/TableSec3/TableLinkedIn'
import Typography from '@mui/material/Typography'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useFormTechnicalAssistance } from '../../../../context/TechnicalAssistanceContext'
import { useAsistencia } from '../../../../context/AsistenciaContext'

export const AsistenciaSeccion3View = (props) => {
  const { assistanceForm } = useFormTechnicalAssistance()
  const { goToStep } = props
  const [, dispatch] = useAsistencia()

  const previous = () => {
    dispatch({ type: 'SET_STATE', payload: 2 })
    goToStep(2)
  }

  const GeneralDataSchema = Yup.object().shape({})

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      SelectionProcessExplanation:
        assistanceForm.SelectionProcessExplanation || '',
      UserAgreesAssistanceContract:
        assistanceForm.UserAgreesAssistanceContract || false,
      NoObjectionRequestCambioII:
        assistanceForm.UserAgreesAssistanceContract || false,
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {},
  })

  return (
    <>
      <form id="Sec3-form">
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">
            Información sobre la Asistencia Técnica utilizada
          </h1>
          <br />
        </Grid>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              1. Términos de referencia para la asistencia técnica solicitada
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Adjunte los términos de referencia de la asistencia técnica
                  solicitada. Incluir información sobre:
                </label>
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">I) Objetivos</label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    II) Lista y descripción de productos y actividades
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    III) Presupuesto detallado
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">IV) Cronograma</label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    V) Resultados esperados de la construcción de capacidades,
                    junto con lo dispuesto para el monitoreo y evaluación para
                    dar seguimiento a la actividad
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    VI) Programación de pagos vinculados con la entrega de
                    productos esperados
                  </label>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="input__container">
                <Table31
                  IdTechnicalAssistanceAnswer={
                    assistanceForm.IdTechnicalAssistanceAnswer
                  }
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              2. Proceso de selección del proveedor de servicios de asistencias
              técnicas que se utilizará, y forma de contratación
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Explique cuál es el procedimiento que utiliza la IFI para
                  seleccionar y contratar servicios de este tipo:
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Procesamiento utilizado para seleccionar y contratar servicios"
                    customInput={TextField}
                    value={formik.values.SelectionProcessExplanation}
                    disabled
                  ></textarea>
                </FormControl>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3. Copia del borrador del contrato con el proveedor de servicios
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Adjunte la copia del borrador del contrato que se firmará con
                  el proveedor de servicios
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Table33
                  IdTechnicalAssistanceAnswer={
                    assistanceForm.IdTechnicalAssistanceAnswer
                  }
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              4. Lista de posibles proveedores del servicio requerido
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Adjunte un CV/perfil detallado de los proveedores de servicios
                  propuestos, incluyendo los datos de contacto (teléfono,
                  dirección y correo electrónico, etc.)
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Table34
                  IdTechnicalAssistanceAnswer={
                    assistanceForm.IdTechnicalAssistanceAnswer
                  }
                />
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">Perfil LinkedIn</label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <TableLinkedIn
                    IdTechnicalAssistanceAnswer={
                      assistanceForm.IdTechnicalAssistanceAnswer
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Grid container spacing={1} className="input__container">
          <Grid item xs={12} sm={12} md={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    value="UserAgreesAssistanceContract"
                    checked={!!formik.values.UserAgreesAssistanceContract}
                    disabled
                  />
                }
                label={
                  <>
                    Yo, <b>{assistanceForm.NameUser}</b>, en nombre de{' '}
                    <b>{assistanceForm.NameIFI}</b>, me comprometo a contratar
                    la Asistencia Técnica reflejada en esta solicitud.
                    <span style={{ color: 'red' }}>*</span>
                  </>
                }
              />
              {formik.errors.UserAgreesAssistanceContract ? (
                <div
                  style={{
                    color: 'red',
                    marginTop: '3px',
                    fontSize: '13px',
                  }}
                >
                  {formik.errors.UserAgreesAssistanceContract}
                </div>
              ) : null}

              <FormControlLabel
                control={
                  <Checkbox
                    value="NoObjectionRequestCambioII"
                    checked={!!formik.values.NoObjectionRequestCambioII}
                    disabled
                  />
                }
                label={
                  <>
                    Solicito al Programa CAMBIO II, la No Objeción para proceder
                    con la Asistencia Técnica para la construcción de
                    capacidades, y contratar al proveedor de servicios para su
                    desarrollo.
                    <span style={{ color: 'red' }}>*</span>
                  </>
                }
              />
              {formik.errors.NoObjectionRequestCambioII ? (
                <div
                  style={{
                    color: 'red',
                    marginTop: '3px',
                    fontSize: '13px',
                  }}
                >
                  {formik.errors.NoObjectionRequestCambioII}
                </div>
              ) : null}
            </FormGroup>
          </Grid>
        </Grid>

        <Grid container spacing={1} className="button__container">
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            style={{ textAlign: 'left' }}
            className="continerButtonNav"
          >
            <Button
              onClick={() => previous()}
              variant="contained"
              className="button__wizard button__previous"
            >
              Anterior
            </Button>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            style={{ textAlign: 'right' }}
            className="continerButtonNav"
          ></Grid>
        </Grid>
      </form>
    </>
  )
}
